module.exports = {
  base_url : process.env.base_url || "https://www.ventokredit.com/",
  api_base_url : process.env.api_base_url || "https://www.ventokredit.com/api/",
};
